import { PRE_CONTRACTUAL_ENDPOINTS } from '@app/configs/api/preContractual';
import { openPdfInNewWindow } from '@app/utils/pdfHandler';
import { baseApi } from './baseApi';
export const preContractualApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getPreContractualAgreement: builder.query({
            query: ({ period, amount, documentType }) => ({
                url: `${PRE_CONTRACTUAL_ENDPOINTS.documents}/${documentType}`,
                params: {
                    period,
                    amount,
                    output: 'html',
                },
            }),
        }),
        getPreContractualInformation: builder.mutation({
            query: ({ period, amount, documentType }) => ({
                url: `${PRE_CONTRACTUAL_ENDPOINTS.documents}/${documentType}`,
                params: {
                    period,
                    amount,
                    output: 'pdf',
                    contentDisposition: 'inline',
                },
                responseType: 'arraybuffer',
            }),
            transformResponse: (response) => {
                openPdfInNewWindow(response);
                return undefined;
            },
        }),
    }),
    overrideExisting: false,
});
export const { useGetPreContractualAgreementQuery, useGetPreContractualInformationMutation } = preContractualApi;
